import React from 'react';
import styled from 'styled-components';
import {Link as RouterLink} from 'react-router-dom';

function Link({to, label, active = false, icon, count, color, external}) {
  const styledIcon = React.cloneElement(icon, {
    size: '1.25em'
  });

  return (
    <Container to={!external ? to :undefined}
               href={external ? to :undefined}
               target={external ? "_blank" : undefined}  // if link goes to external open in new window
               rel={external ? "noopener noreferrer" : undefined} // ensure noopener and noreferrer is set on href
               active={active} color={color} external={external} >
      <Dot visible={active} color={color}/>
      <IconContainer color={color}>
        {styledIcon}
      </IconContainer>
      <Label>{label}</Label>
      {count && <Count>{count}</Count>}
    </Container>
  );
}

const Container = styled(({active, external, children, ...props}) =>
    external ? <a {...props}> {children} </a> : <RouterLink {...props}> {children} </RouterLink>)`
  display: flex;
  align-items: center;
  flex-direction: row;
  box-sizing: border-box;
  height: 3rem;
  text-decoration: none;
  font-size: 1rem;
  color: ${props => props.color || '#fff'} !important;
  background: ${props => props.active ? 'rgba(0, 0, 0, 0.2)' : 'transparent'};

  :hover {
    background: rgba(0, 0, 0, 0.2);
  }
`;

const Dot = styled.div`
  height: 0.4rem;
  width: 0.4rem;
  margin-left: -0.2rem;
  border-radius: 100%;
  background: ${props => props.visible ? props.color || 'white' : 'transparent'};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  color: ${props => props.color} || '#fff'
`;

const Label = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const Count = styled.div`
  background: #F64040;
  color: #fff;
  box-shadow: 0 1px 4px rgba(126, 42, 42, 0.5);
  padding: 0.125rem 0.4rem;
  font-size: 0.8rem;
  border-radius: 100%;
  margin-right: 1rem;
`;

export default Link;